import Header from "./Header";
import React, {HTMLProps} from "react";
import {Outlet} from "react-router-dom";

const Layout = (props: HTMLProps<HTMLDivElement>) => (
    <div className={"flex flex-col w-full h-full items-center"}>
        <Header />
        <div className={"flex w-full max-w-xl justify-center py-4 px-2 md:px-0"}>
            <Outlet />
        </div>
    </div>
)

export default Layout;